export default __webpack_public_path__ + "static/media/doc-signed.9b4b8fe4.png";